export default __webpack_public_path__ + "static/media/free.e9186dae.svg";